<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-area" *ngIf="!isLoading">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumnInSiteList($event)">
        <colgroup>
          <col *ngFor="let col of siteTableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of siteTableHeader" [sortable-column]="header.value">
               {{header.name}}</th>
          </tr>
        </thead>
      </table>
      <div class="alternative-contents" *ngIf="determineElementToShowInSiteListTable() === 'no-data'"> <i class="material-icons">people</i>
        <div>No Customer</div>
        <div>Create a customer to provide your service.</div>
      </div>
      <div class="alternative-contents" *ngIf="determineElementToShowInSiteListTable() === 'no-permission'"> <i class="material-icons">do_not_disturb_on</i>
        <div>Permission Denied</div>
      </div>
      <div class="table-body" *ngIf="determineElementToShowInSiteListTable() === 'normal'">
        <table>
          <colgroup>
            <col *ngFor="let col of siteTableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <tr *ngIf="pagedItems?.length === 0 && !isLoading" style="text-align: center; color: #999;">
              <td colspan="11">No Service Note</td>
            </tr>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let site of pagedItems">
                <td>{{site.site_id}}</td>
                <td [class.unknown]="site.name === 'No Site Name'"> 
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                    <div class="ellipsis">{{site.name}}</div>
                    <div class="--g-tooltip tooltip-background">{{site.name}}</div>
                  </div>
                </td>
                <td [class.unknown]="site.dealer_name === 'No Dealer Name'"> 
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                    <div class="ellipsis">{{site.dealer_name}}</div>
                    <div class="--g-tooltip tooltip-background">{{site.dealer_name}}</div>
                  </div>
                </td>
                <td> 
                  <div class="v-center" style="gap: 4px; flex-wrap: wrap;">
                    <div *ngFor="let note of site.service_notes">
                      <div class="service-note-tag"><span>{{note.type}} : </span><span class="text-black">{{note.count}}</span></div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="v-center" style="gap: 4px; flex-wrap: wrap;">
                    <div *ngFor="let direction of site.mp_directions">
                      <div class="small-font v-center" [ngClass]="computedStatusLabelColor(direction)"> <i class="material-icons-outlined" style="margin-right: 5px; font-size: 14px" *ngIf="computedStatusLabelIcon(direction)">{{ computedStatusLabelIcon(direction) }}</i>
                        <div>{{direction.type}} : </div>
                        <div class="text-black">{{direction.count}}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="more-content v-center" #siteActionMenus [id]="site.site_id" (mouseover)="setMorePosition(site.site_id)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(site)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="site.isShowMenu" [id]="'more-'+site.site_id">
                      <div class="more-item text-primary row" *ngIf="isShowGoToServiceNoteButton(site)" (click)="moveToServiceNote($event, site)">
                        <div>Go to Service Notes →</div>
                      </div>
                      <div class="more-item text-primary row" (click)="moveToMpDirection($event, site)">
                        <div>Go to MP directions →</div>
                      </div>
                      <div class="more-item row" (click)="goToSite($event, site.site_id)">
                        <div>Go to Site</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- SLOT : pagination-->
      <div class="pagination-area">
        <div style="font-size:12px;padding-right: 7px;"></div>
        <div class="space"></div>
        <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
          <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
          <div>of </div>
          <div>{{totalItem}}</div>
        </div>
        <div class="pagination">
          <div class="page-mover">
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
                <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
              </div>
            </div>
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
                <div class="btn-inner"><span>Next</span>
                  <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>